import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AppSessionService } from "../app-session/app-session.service";
import { catchError, map } from "rxjs/operators";
import { setAdvancedFilterQuery, setSimpleFilterQuery } from "../../utils/tableUtils";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { GridUtils } from "../../utils/gridUtils";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class PosService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  createPos(pos: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(pos);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/pos"}`;
    return this.http.post(url, data, { headers });
  }

  updatePos(pos: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(pos);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/pos"}/${
      pos?.code
    }`;
    return this.http.put(url, data, { headers });
  }

  getDevicesPos(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    const url = paging
      ? this.buildDataUrl(paging, `${this.appSession.baseUrl}/api/v1/devices/pos`)
      : `${this.appSession.baseUrl}/api/v1/devices/pos`;
    
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  // Grid filter helpers block
    private buildDataUrl(pagingArgs: any, path: string): string {
      let baseQueryString = `${path}`;
      let scrollingQuery = EMPTY_STRING;
      let query = EMPTY_STRING;
  
      if (pagingArgs) {
        scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
      }
  
      query += scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;
      baseQueryString += query;
  
      return baseQueryString;
    }
}
